export default "__VITE_ASSET__oWehRr5J__"